import { render, staticRenderFns } from "./Mailchimp.vue?vue&type=template&id=54ecfd80&scoped=true"
import script from "./Mailchimp.vue?vue&type=script&lang=js"
export * from "./Mailchimp.vue?vue&type=script&lang=js"
import style0 from "./Mailchimp.vue?vue&type=style&index=0&id=54ecfd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ecfd80",
  null
  
)

export default component.exports